import { WorkloadTypesEnum, WorkloadTypesEnumDisplayNameChanged } from '../../../types';
import { AssumptionsState, AssumptionsValues } from './assumptions.types';

const pricingInitialState = {
    business: 0,
    enterprise: 0,
    elite: 0,
    govCloudAddon: 0,
    data: [
        {
            pricing: 'Business',
            cost: '',
            perMonth: '/TB/m',
            key: 'business',
        },
        {
            pricing: 'Enterprise',
            cost: '',
            perMonth: '/TB/m',
            key: 'enterprise',
        },
        {
            pricing: 'Elite',
            cost: '',
            perMonth: '/TB/m',
            key: 'elite',
        },
        {
            pricing: 'GovCloud Addon',
            cost: '',
            perMonth: '/TB/m',
            key: 'govCloudAddon',
        },
    ],
};
export const assumptionsInitialState: AssumptionsState = {
    defaultAssumptions: {} as AssumptionsValues,
    isOpen: false,
    isEditing: false,
    isAssumptionsDialogOpen: false,
    dedupe: {
        nas: 2.5,
        dtc: 1,
        windows: 2.5,
        linux: 2.5,
        msSql: 1.3,
        oracle: 1.3,
        vMware: 3,
        hyperV: 3,
        nutanixAhv: 3,
        archiveFsNas: 1,
        ec2: 3,
        sapHana: 1.3,
        azureVm: 3,
        rds: 1,
        awsS3: 2.5,
        azureSql: 1.3,
        azureBlob: 2.5,
        azureFiles: 2.5,
        data: [
            {
                dataTypesAndDedupeRatio: 'Cloud Workloads',
                workloadType: WorkloadTypesEnum.EC2,
                workloadTypeLabel: WorkloadTypesEnumDisplayNameChanged.EC2,
                dedupe: 3.0,
                key: 'ec2',
            },
            {
                dataTypesAndDedupeRatio: '',
                workloadType: WorkloadTypesEnum.RDS,
                workloadTypeLabel: WorkloadTypesEnumDisplayNameChanged.RDS,
                dedupe: 1.0,
                key: 'rds',
            },
            {
                dataTypesAndDedupeRatio: '',
                workloadType: WorkloadTypesEnum.AWSS3,
                workloadTypeLabel: WorkloadTypesEnum.AWSS3,
                dedupe: 2.5,
                key: 'awsS3',
            },
            {
                dataTypesAndDedupeRatio: '',
                workloadType: WorkloadTypesEnum.AZUREVM,
                workloadTypeLabel: WorkloadTypesEnum.AZUREVM,
                dedupe: 3.0,
                key: 'azureVm',
            },
            {
                dataTypesAndDedupeRatio: '',
                workloadType: WorkloadTypesEnum.AZURESQL,
                workloadTypeLabel: WorkloadTypesEnum.AZURESQL,
                dedupe: 1.3,
                key: 'azureSql',
            },
            {
                dataTypesAndDedupeRatio: '',
                workloadType: WorkloadTypesEnum.AZUREBLOB,
                workloadTypeLabel: WorkloadTypesEnum.AZUREBLOB,
                dedupe: 2.5,
                key: 'azureBlob',
            },
            {
                dataTypesAndDedupeRatio: '',
                workloadType: WorkloadTypesEnum.AZUREFILES,
                workloadTypeLabel: WorkloadTypesEnum.AZUREFILES,
                dedupe: 2.5,
                key: 'azureFiles',
            },
            {
                dataTypesAndDedupeRatio: 'VM',
                workloadType: WorkloadTypesEnum.VMWARE,
                workloadTypeLabel: WorkloadTypesEnum.VMWARE,
                dedupe: 3.0,
                key: 'vMware',
            },
            {
                dataTypesAndDedupeRatio: '',
                workloadType: WorkloadTypesEnum.HYPERV,
                workloadTypeLabel: WorkloadTypesEnum.HYPERV,
                dedupe: 3.0,
                key: 'hyperV',
            },
            {
                dataTypesAndDedupeRatio: '',
                workloadType: WorkloadTypesEnum.NUTANIXAHV,
                workloadTypeLabel: WorkloadTypesEnum.NUTANIXAHV,
                dedupe: 3.0,
                key: 'nutanixAhv',
            },
            {
                dataTypesAndDedupeRatio: 'Files',
                workloadType: WorkloadTypesEnum.NAS,
                workloadTypeLabel: WorkloadTypesEnum.NAS,
                dedupe: 2.5,
                key: 'nas',
            },
            {
                dataTypesAndDedupeRatio: '',
                workloadType: WorkloadTypesEnum.WINDOWS,
                workloadTypeLabel: WorkloadTypesEnum.WINDOWS,
                dedupe: 2.5,
                key: 'windows',
            },
            {
                dataTypesAndDedupeRatio: '',
                workloadType: WorkloadTypesEnum.LINUX,
                workloadTypeLabel: WorkloadTypesEnum.LINUX,
                dedupe: 2.5,
                key: 'linux',
            },
            {
                dataTypesAndDedupeRatio: 'Archive',
                workloadType: WorkloadTypesEnum.ARCHIVEFSNAS,
                workloadTypeLabel: WorkloadTypesEnum.ARCHIVEFSNAS,
                dedupe: 1.0,
                key: 'archiveFsNas',
            },
            {
                dataTypesAndDedupeRatio: 'Database',
                workloadType: WorkloadTypesEnum.MSSQL,
                workloadTypeLabel: WorkloadTypesEnum.MSSQL,
                dedupe: 1.3,
                key: 'msSql',
            },
            {
                dataTypesAndDedupeRatio: '',
                workloadType: WorkloadTypesEnum.ORACLE,
                workloadTypeLabel: WorkloadTypesEnum.ORACLE,
                dedupe: 1.3,
                key: 'oracle',
            },
            {
                dataTypesAndDedupeRatio: '',
                workloadType: WorkloadTypesEnum.SAPHANA,
                workloadTypeLabel: WorkloadTypesEnum.SAPHANA,
                dedupe: 1.3,
                key: 'sapHana',
            },
        ],
    },
    ltr: {
        ltr: 0.8,
        data: [
            {
                ltrCreditRate: 'LTR credit rate',
                empty: '',
                credit: 0.8,
                key: 'ltr',
            },
        ],
    },
    dtc: {
        dtc: 0.5,
        data: [
            {
                dtcCreditRate: 'Archive credit rate',
                empty: '',
                credit: 0.5,
                key: 'dtc',
            },
        ],
    },
    cloudNativePricing: pricingInitialState,
    hybridPricing: pricingInitialState,
    changeRates: {
        weeklyMultiplier: 3,
        weeklyCap: 0.07,
        monthlyMultiplier: 8,
        monthlyCap: 0.2,
        yearlyMultiplier: 35,
        yearlyCap: 0.5,
        data: [
            {
                changesRates: 'Weekly change rate',
                multiplier: 3,
                cap: 0.07,
                keyMultiplier: 'weeklyMultiplier',
                keyCap: 'weeklyCap',
            },
            {
                changesRates: 'Monthly change rate',
                multiplier: 8,
                cap: 0.2,
                keyMultiplier: 'monthlyMultiplier',
                keyCap: 'monthlyCap',
            },
            {
                changesRates: 'Yearly change rate',
                multiplier: 35,
                cap: 0.5,
                keyMultiplier: 'yearlyMultiplier',
                keyCap: 'yearlyCap',
            },
        ],
    },
};
